import { createSelector } from '@reduxjs/toolkit';

import { type RootState } from '../stores';

export const configBaseSelector = (state: RootState) => state.configDetails;

export const leadAttributesSelector = createSelector(
  configBaseSelector,
  (configDetails) => configDetails.leadAttributes,
);

export const leadStagesSelector = createSelector(
  configBaseSelector,
  (configDetails) => configDetails.leadStageOptions,
);

export const leadSourceOptionsSelector = createSelector(
  configBaseSelector,
  (configDetails) => configDetails.leadSourceOptions,
);

export const leadAttributeOptionsSelector = createSelector(
  configBaseSelector,
  (configDetails) => configDetails.leadAttributeOptions,
);

export const getLeadAttributeOption = (id: string) => createSelector(
  leadAttributeOptionsSelector,
  (leadAttributeOptions) => leadAttributeOptions.find((option) => option.id === id),
);
